import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

// --- Interfaces ---
import type {
	IFeatures,
	IPricingTiers,
	ITenant,
	ITenants,
} from '@interfaces/tenants';

export interface IGetTenantsParams {
	search?: string;
	inactive?: boolean;
	inactivatedAfter?: Date;
	tenantId?: number;
	page?: number;
	pageLimit?: number;
}

@Injectable({
	providedIn: 'root',
})
export class TenantsService {
	constructor(private readonly _http: HttpClient) {}

	// --- GET endpoints ---
	getTenants(queryParams?: IGetTenantsParams) {
		return this._http.get<ITenants>('Tenants', {
			params: (<unknown>queryParams) as HttpParams,
		});
	}

	getTenantById(id: ITenant['id']) {
		return this._http.get<ITenant>(`Tenants/${id}`);
	}

	// --- POST endpoints ---
	newTenant(Tenant: ITenant) {
		return this._http.post<ITenant>(`Tenants`, Tenant);
	}

	activate(id: ITenant['id']) {
		return this._http.post<ITenant>(`Tenants/${id}/activate`, {});
	}

	// --- PUT endpoints ---
	updateTenant(id: ITenant['id'], Tenant: ITenant) {
		return this._http.put<ITenant>(`Tenants/${id}`, Tenant);
	}

	updateFeatures(id: ITenant['id'], features: IFeatures) {
		return this._http.put<IFeatures>(`Tenants/${id}/features`, features);
	}

	// --- DELETE endpoints ---
	deleteTenant(id: ITenant['id']) {
		return this._http.delete<ITenant>(`Tenants/${id}`);
	}

	// PLANS
	getPricingTiers() {
		return this._http.get<IPricingTiers[]>('pricing_tiers', {});
	}
}
